// extracted by mini-css-extract-plugin
export default {"productDescription":"yea-z","featuredDescription":"zea-z","description":"Aea-z","more":"Bea-z","descriptionSku":"Cea-z"};